import { useEffect } from 'react';
import { MANAGED_ATTRIBUTE, NOINDEX_CONTENT } from '@/lib/seo/metadata';

/**
 * Keeps a non-public surface out of search results for the whole time it is on
 * screen: authenticated application pages, the sign-in and sign-up flows,
 * unlisted report share links, and the not-found page.
 *
 * robots.txt already disallows these paths, but a crawler that reaches one by
 * following a link — or that ignores robots.txt — still needs the page itself
 * to say so. Applied at the layout level so every page under it is covered.
 */
export function useNoindex() {
  useEffect(() => {
    const existing = document.head.querySelector('meta[name="robots"]');
    if (existing) {
      const previous = existing.getAttribute('content');
      existing.setAttribute('content', NOINDEX_CONTENT);
      return () => {
        if (previous === null) existing.removeAttribute('content');
        else existing.setAttribute('content', previous);
      };
    }

    const created = document.createElement('meta');
    created.setAttribute('name', 'robots');
    created.setAttribute('content', NOINDEX_CONTENT);
    created.setAttribute(MANAGED_ATTRIBUTE, 'true');
    document.head.appendChild(created);
    return () => created.remove();
  }, []);
}
